<ng-content select="[data-icon]"></ng-content>
<ng-content select="[data-header]"></ng-content>
<ng-content select="[data-subtitle]"></ng-content>
<ng-content select="[data-call-to-action]"></ng-content>
